import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_location: window.location.href, // full URL
        page_title: document.title, // or a more dynamic title if you set it per page
      });
    // console.log('GA4 page_view sent:', location.pathname + location.search);
    }
  }, [location]); // Re-run effect when location changes
};

export default useTracking;